import SiafLiteApiRepository from "../../external/siafLiteApi";

class ServicoRecorrenteService {
  constructor() {
    this.urlBase = "/faturamento/servicos-recorrentes";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  atualizarStatus(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  enviarMensagemLote(body) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/mensagem-lote`,
    ).patch(body);
  }
}

export default ServicoRecorrenteService;
